import React from 'react';
import ImageComponent from 'atoms/Image/index';
import FormComponent from 'atoms/FormComponent';
import PayGateCreditDebitCardHiddenForm from 'organisms/Payment/hiddenForms/PayGateCreditDebitCardHiddenForm';

const DonateView = props => {
  const { segmentedAddHopeData, isMobile, paymentData, donationsButtonData, updateAddHopeDetails, addHopeDetails } =
    props;
  return (
    <div className='add-hope-container'>
      <div className='add-hope-banner-block col-12'>
        <ImageComponent
          className='banner-image'
          data-testid='product-image'
          srcFile={isMobile ? segmentedAddHopeData.mobileImage : segmentedAddHopeData.desktopImage}
          alt='text'
        />
      </div>
      <div className='add-hope-content-area content-area wrapper-content'>
        <p className='addhope-display-paragraph'>{segmentedAddHopeData.headLine}</p>
        <h2 className='add-hope-title'>{segmentedAddHopeData.shortText}</h2>
        <h5 className='add-hope-longtext'>{segmentedAddHopeData.longText}</h5>
        <p className='addhope-display-paragraph'>{segmentedAddHopeData.richText1}</p>
        <p className='addhope-display-paragraph'>{segmentedAddHopeData.richText2}</p>
        <p className='addhope-display-paragraph'>{segmentedAddHopeData.richText3}</p>
        <div className={`row row-cols-12 mt-10px`}>
          <div className=' col-sm-2 col-12'>
            <ImageComponent
              data-testid='product-image'
              srcFile={segmentedAddHopeData.bucketImage}
              className='add-hope-bucket-img'
              alt='text'
            />
          </div>
          <div className='col-sm-8 col-12'>
            <ul className='add-hope-unordered-list'>
              {segmentedAddHopeData.displayLine1 &&
                segmentedAddHopeData.displayLine1
                  .split(' ')
                  .join('')
                  .split('')
                  .map(val => <li className='add-hope-list'> {val}</li>)}
            </ul>
            <span className='add-hope-text-new'>{segmentedAddHopeData.displayLine2}</span>
          </div>
        </div>
      </div>
      <div className='addHopeFormContainer'>
        <div className={`row row-cols-12 mt-10px`}>
          <div className='labelContent-addHope info-label pl-25px col-sm-2 col-12'>
            <span>{segmentedAddHopeData.addHopeFormTitle}</span>
          </div>
          <div className='donate-details px-25px col-sm-8 col-12'>
            <div className='tip-text-donate'>{segmentedAddHopeData.addHopeFormHeadLine}</div>
          </div>
        </div>
        <div className='donate-form-details px-25px col-sm-10 col-12'>
          {addHopeDetails?.addHopeFormConfig?.fieldsConfig?.length && (
            <div className='mt-4 contactInfoContent col-12  d-flex'>
              <div className='col-12'>
                <FormComponent
                  formConfig={{
                    ...addHopeDetails?.addHopeFormConfig,
                    addHopeDetails,
                    updateAddHopeDetails,
                  }}
                />
              </div>
            </div>
          )}
          {donationsButtonData?.isAddHopeButtonClicked && paymentData?.redirectUri && (
            <PayGateCreditDebitCardHiddenForm formData={paymentData} />
          )}
        </div>
        <div className='labelContent-addHope info-label-snapscan pl-25px '>
          <span>{segmentedAddHopeData.snapScanHeadline}</span>
        </div>
        <div className='donate-details-snapscan px-25px '>
          <a href={segmentedAddHopeData.snapScanExternalURL}>
            <ImageComponent data-testid='product-image' srcFile={segmentedAddHopeData.snapScanImage} alt='text' />
          </a>
        </div>
      </div>
    </div>
  );
};

export default DonateView;
